
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.1199 6.28L14.4999 6.92L12.9999 5.77V3.88V3.4C12.9999 3.14 13.2199 2.92 13.4999 2.92C13.7299 2.92 13.9299 3.08 13.9899 3.28C14.0999 3.7 14.4899 4 14.9399 4C15.4899 4 15.9399 3.55 15.9399 3C15.9399 2.9 15.9199 2.8 15.8899 2.7C15.5899 1.72 14.6299 1 13.4999 1C12.1199 1 10.9999 2.07 10.9999 3.4V3.88V5.77L9.49988 6.92L6.87988 6.28C6.49988 6.19 6.15988 6.55 6.27988 6.92L11.0499 21.31C11.1999 21.77 11.5999 22 11.9999 22C12.3999 22 12.7999 21.77 12.9499 21.31L17.7199 6.92C17.8399 6.55 17.4999 6.19 17.1199 6.28ZM10.9999 14.8L9.02988 8.86L9.94988 9.09L10.7099 8.51L10.9999 8.29V14.8ZM12.9999 14.8V8.29L13.2799 8.51L14.0399 9.09L14.9599 8.86L12.9999 14.8Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-umbrella`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconUmbrella

    ```js
    <b-new-b-icon-umbrella />
    ```
</docs>


